var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "flex flex-col md:flex-row pb-4 px-20" }, [
      _c("div", { staticClass: "flex-1 flex flex-col md:flex-row" }, [
        _c("div", { staticClass: "w-full flex-1 mx-2" }, [
          _c("div", { staticClass: "my-2 p-1 flex" }, [
            _c("img", { attrs: { src: _vm.song.cover, width: "200px" } })
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "flex flex-col md:flex-row border-b border-gray-200 pb-4"
      },
      [
        _c(
          "div",
          { staticClass: "w-64 font-bold h-6 mx-2 mt-3 text-gray-800" },
          [_vm._v("Song Name")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex-1 flex flex-col md:flex-row" }, [
          _c("div", { staticClass: "w-full flex-1 mx-2" }, [
            _c("div", { staticClass: "my-2 p-1 flex" }, [
              _c("p", [_vm._v(_vm._s(_vm.song.title))])
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "flex flex-col md:flex-row border-b border-gray-200 pb-4"
      },
      [
        _c(
          "div",
          { staticClass: "w-64 font-bold h-6 mx-2 mt-3 text-gray-800" },
          [_vm._v("Category")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex-1 flex flex-col md:flex-row" }, [
          _c("div", { staticClass: "w-full flex-1 mx-2" }, [
            _c("div", { staticClass: "my-2 p-1 flex" }, [
              _c("p", [_vm._v(_vm._s(_vm.song.genre))])
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "flex flex-col md:flex-row border-b border-gray-200 pb-4"
      },
      [
        _c(
          "div",
          { staticClass: "w-64 font-bold h-6 mx-2 mt-3 text-gray-800" },
          [_vm._v("Year")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex-1 flex flex-col md:flex-row" }, [
          _c("div", { staticClass: "w-full flex-1 mx-2" }, [
            _c("div", { staticClass: "my-2 p-1 flex" }, [
              _c("p", [_vm._v(_vm._s(_vm.song.year))])
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "flex flex-col md:flex-row border-b border-gray-200 pb-4"
      },
      [
        _c(
          "div",
          { staticClass: "w-64 font-bold h-6 mx-2 mt-3 text-gray-800" },
          [_vm._v("File Song")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex-1 flex flex-col md:flex-row" }, [
          _c("div", { staticClass: "w-full flex-1 mx-2" }, [
            _c("div", { staticClass: "my-2 p-1 flex" }, [
              _c(
                "audio",
                {
                  attrs: {
                    controls: "",
                    src: _vm.song.file,
                    controlsList: "nodownload",
                    type: "audio/mp3",
                    preload: "none"
                  }
                },
                [_vm._v("\n            Audio tag not supported\n          ")]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "flex flex-col md:flex-row border-b border-gray-200 pb-4"
      },
      [
        _c(
          "div",
          { staticClass: "w-64 font-bold h-6 mx-2 mt-3 text-gray-800" },
          [_vm._v("Language")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex-1 flex flex-col md:flex-row" }, [
          _c("div", { staticClass: "w-full flex-1 mx-2" }, [
            _c("div", { staticClass: "my-2 p-1 flex" }, [
              _c("p", [_vm._v(_vm._s(_vm.languages))])
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "flex flex-col md:flex-row border-b border-gray-200 pb-4"
      },
      [
        _c(
          "div",
          { staticClass: "w-64 font-bold h-6 mx-2 mt-3 text-gray-800" },
          [_vm._v("Copyright")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex-1 flex flex-col md:flex-row" }, [
          _c("div", { staticClass: "w-full flex-1 mx-2" }, [
            _c("div", { staticClass: "my-2 p-1 flex" }, [
              !!_vm.song.copyright
                ? _c(
                    "a",
                    {
                      staticClass: "underline font-bold",
                      attrs: { href: _vm.song.copyright, target: "_blank" }
                    },
                    [_vm._v("Copyright Link")]
                  )
                : _c("p", [_vm._v("-")])
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "flex flex-col md:flex-row border-b border-gray-200 pb-4"
      },
      [
        _c(
          "div",
          { staticClass: "w-64 font-bold h-6 mx-2 mt-3 text-gray-800" },
          [_vm._v("Subscription")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex-1 flex flex-col md:flex-row" }, [
          _c("div", { staticClass: "w-full flex-1 mx-2" }, [
            _c("div", { staticClass: "my-2 p-1 flex" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.song.is_subscription ? "Yes" : "No") +
                  "\n        "
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "flex flex-col md:flex-row border-b border-gray-200 pb-4"
      },
      [
        _c(
          "div",
          { staticClass: "w-64 font-bold h-6 mx-2 mt-3 text-gray-800" },
          [_vm._v("Song Price (USD)")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "flex-1 flex flex-col md:flex-row" }, [
          _c("div", { staticClass: "w-full flex-1 mx-2" }, [
            _c("div", { staticClass: "my-2 p-1 flex" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.song.price == 0
                      ? "Free"
                      : "$ " +
                          "" +
                          parseFloat(_vm.toDollar(_vm.song.price)).toFixed(2)
                  ) +
                  "\n             = " +
                  _vm._s(parseFloat(_vm.song.price).toFixed(2)) +
                  " Credits\n        "
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d683bf5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d683bf5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/contents/SongDetail.vue
// module id = null
// module chunks = 